export enum Steps {
  AGREEMENT = 'agreement',
}
